import { FilterCheckbox, translateServices, useBokaServices } from "@repo/ui";
import { hasItems, isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const BokaServiceFilter = ({ actions, filters }: FilterItemsProps) => {
  const bokaServicesList = useBokaServices();

  return (
    <FilterListContainer id="boka-service-filter">
      {hasItems(bokaServicesList) &&
        bokaServicesList.map((key) => (
          <FilterCheckbox
            key={key}
            id={key}
            value={key}
            label={translateServices(key) ?? "-"}
            checked={isChecked(filters.bokaServices, key)}
            onCheckFilter={actions.setBokaServices}
          />
        ))}
    </FilterListContainer>
  );
};
